const XL_BREAKPOINT = 1280;

let isMenuOpen = false;

function getMenuElements() {
	const mainMenu = document.querySelector("#mainMenu");
	const menuToggle = document.querySelector("#menu-toggle");
	return { mainMenu, menuToggle };
}

function isDesktop() {
	return window.innerWidth >= XL_BREAKPOINT;
}

function applyMenuHeight() {
	const { mainMenu } = getMenuElements();
	if (!mainMenu) return;

	if (isDesktop()) {
		mainMenu.style.maxHeight = "";
		return;
	}

	mainMenu.style.maxHeight = isMenuOpen ? `${mainMenu.scrollHeight}px` : "0px";
}

export function setActiveMenuState() {
	applyMenuHeight();
}

export function ResetMenuState() {
	isMenuOpen = false;
	applyMenuHeight();
}

export function CloseMenu() {
	ResetMenuState();
}

export function InstanceMenu() {
	Menu();
}

export const Menu = () => {
	const { mainMenu, menuToggle } = getMenuElements();
	if (!mainMenu || !menuToggle) return;

	if (menuToggle.dataset.menuBound === "true") {
		applyMenuHeight();
		return;
	}

	menuToggle.dataset.menuBound = "true";

	ResetMenuState();

	menuToggle.addEventListener("click", () => {
		if (isDesktop()) return;
		isMenuOpen = !isMenuOpen;
		applyMenuHeight();
	});

	window.addEventListener("resize", applyMenuHeight);
};
